import trackWalkingTimeFiltered from 'segment/events/walking-time-filtered';
export const FILTERS_RESET = 'FILTERS_RESET';
export const FILTERS_UPDATE = 'FILTERS_UPDATE';
export const FILTER_SET_SHOW_TOTAL = 'SEARCH_SET_SHOW_TOTAL';
export const SEARCH_SET_LOYALTY_PROGRAM = 'SEARCH_SET_LOYALTY_PROGRAM';
export const FILTER_GET_SESSION = 'FILTER_GET_SESSION';
export const FILTER_SET_SHOW_UNAVAILABLE = 'FILTER_SET_SHOW_UNAVAILABLE';
export const resetFilters = () => {
    return {
        type: FILTERS_RESET,
    };
};
// Used https://github.com/spothero/consumer-web/blob/d7dcd7cc428a0e84e7f7265a90b62df82a0208ac/src/js/common/search-filters-controls/QuickFilters.tsx#L229
export const getFiltersSession = () => {
    return {
        type: FILTER_GET_SESSION,
    };
};
export const updateFilters = (toUpdate) => {
    return {
        type: FILTERS_UPDATE,
        payload: toUpdate,
    };
};
export const setWalkingDistanceLimitInMinutesFilter = (walkingDistanceLimitInMinutes, isSegmentTrackingEnabled = true) => {
    return (dispatch) => {
        if (isSegmentTrackingEnabled) {
            trackWalkingTimeFiltered({
                walkingTime: walkingDistanceLimitInMinutes,
            });
        }
        dispatch({
            type: FILTERS_UPDATE,
            payload: { walkingDistanceLimitInMinutes },
        });
    };
};
/**
 * @description
 * This function toggles the showTotal which is used to ensure compliance with California Regulation that means we cant hide any fees upfront.
 * @example
 * dispatch(toggleShowTotal()); // sets stateBoolean to !stateBoolean
 */
export const toggleShowTotal = (payload) => ({
    type: FILTER_SET_SHOW_TOTAL,
    payload,
});
/**
 * @description
 * This function toggles the loyaltyProgram filter which is used to filter by spots that are part of a loyalty program the user is part of.
 * At first just using this for Colonial spots in DC
 * @example
 * dispatch(toggleLoyaltyProgram()); // sets state to LoyaltyProgramFilterValue
 */
export const toggleLoyaltyProgram = (payload) => ({
    type: SEARCH_SET_LOYALTY_PROGRAM,
    payload,
});
export const toggleShowUnavailable = (payload) => ({
    type: FILTER_SET_SHOW_UNAVAILABLE,
    payload,
});
